import { api } from '../../api-helper';
import { URLS } from '../../../constants/URLS';
export const login = (email, pw) => {
  return api.post(
    URLS.login,
    {
      user: {
        email: email,
        password: pw
      }
    },
    {
      headers: {
        needsToken: false
      }
    }
  );
};

export const resetPassword = (email) => {
  return api.post(
    URLS.usersPassword,
    {
      user: {
        email: email
      }
    },
    {
      headers: {
        needsToken: false
      }
    }
  );
};

export const setPassword = (passwordData) => {
  return api.put(URLS.usersPassword, passwordData, {
    headers: {
      needsToken: false
    }
  });
};

export const getUser = () => {
  return api.get(URLS.user, {
    headers: {
      needsToken: true
    }
  });
};

export const updateUser = (userData) => {
  return api.put(URLS.user, userData, {
    headers: {
      needsToken: true
    }
  });
};
export const changePassword = (passwordData) => {
  return api.put(URLS.changePassword, passwordData, {
    headers: {
      needsToken: true
    }
  });
};

export const getAccessList = () => {
  return api.get(URLS.getAccessList, {
    headers: {
      needsToken: true
    }
  });
};

export const getRoles = (isClient = false) => {
  return api.post(
    URLS.roles,
    {
      isClient: isClient
    },
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const getPeoples = (page = 1, limit = 15, searchQuery = '') => {
  return api.get(URLS.peoples, {
    params: {
      page,
      limit,
      ...(searchQuery?.trim() && { query: searchQuery.trim() })
    },
    headers: {
      needsToken: true
    }
  });
};

export const updatePeople = (peopleID, peopleData) => {
  return api.put(`${URLS.people}?id=${peopleID}`, peopleData, {
    headers: {
      needsToken: true
    }
  });
};

export const deletePeople = (peopleID, replaceOwners) => {
  const config = {
    headers: {
      needsToken: true
    }
  };
  if (replaceOwners?.length) {
    config.data = { replaceOwners };
  }
  return api.delete(`${URLS.people}?id=${peopleID}`, config);
};

export const deleteTeam = (teamID) => {
  return api.delete(`${URLS.team}?id=${teamID}`, {
    headers: {
      needsToken: true
    }
  });
};

export const updateTeam = (teamID, teamData) => {
  return api.put(`${URLS.team}?id=${teamID}`, teamData, {
    headers: {
      needsToken: true
    }
  });
};

export const createTeam = (teamData) => {
  return api.post(URLS.team, teamData, {
    headers: {
      needsToken: true
    }
  });
};

export const sendInvitation = (invitationData) => {
  return api.post(URLS.invitation, invitationData, {
    headers: {
      needsToken: true
    }
  });
};

export const getInvitation = (invitationID) => {
  return api.get(`${URLS.invitation}?id=${invitationID}`);
};

export const addUserByInvitation = (userData) => {
  return api.put(URLS.invitation, userData, {
    headers: {
      needsToken: true
    }
  });
};

export const getAssigneesOrderUniqueIds = (id, attributeIDs, section) => {
  return api.post(
    URLS.assigneesOrderUniqueIds,
    {
      id,
      attributeIds: attributeIDs,
      section
    },
    {
      headers: {
        needsToken: true
      }
    }
  );
};
